import { Outlet } from 'react-router-dom'
import { setAxiosSpaceContext } from '@/utils/axios.js'
import { useCurrentSpace } from '@/hooks/useCurrentSpace.jsx'
import { useEffect } from 'react'
import { toggleAppBanner } from '@/hooks/useAppBanner'

export default function SpaceGuard() {

    const { space, isDemoSpace } = useCurrentSpace()

    if (!space) {
        // User try to access non-existing account, meaning he doesn't have access to it
        console.log('No space?')
        return
    }

    setAxiosSpaceContext(space._id)

    useEffect(() => {
        if (isDemoSpace) {
            toggleAppBanner("demo-space")
        }
    }, [isDemoSpace])

    return <Outlet />
}